import "buefy/dist/buefy.css";
import Vue from "vue";
import App from "./App.vue";
import Buefy from "buefy";

Vue.config.productionTip = false;

import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);
Vue.use(Buefy);
new Vue({
  render: h => h(App)
}).$mount("#app");
